// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTermAcceptances_ListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /lgpd_term_acceptances/index_api
 *
 * Filters: term_id, cliente_id, franquia_id, data_inicio, data_fim.
 * Pagination: limit, offset.
 *
 * Frontend POSTs filters as a JSON body (see useLgpdAdmin.listAcceptances).
 * 'params' was a typo — the only valid sources in MY_Controller::readInputData
 * are 'json' | 'query' | 'upload', and 'params' would hit the
 * "Unknown input source" branch and 500 the request.
 */
import { registerContract } from './validate'

export interface LgpdTermAcceptances_ListInput {
term_id?: number
cliente_id?: number
franquia_id?: number
data_inicio?: string
data_fim?: string
limit?: number
offset?: number
}

registerContract('LgpdTermAcceptances_ListInput', {
  term_id:     { type: 'number',  required: false },
  cliente_id:  { type: 'number',  required: false },
  franquia_id: { type: 'number',  required: false },
  data_inicio: { type: 'string',  required: false },
  data_fim:    { type: 'string',  required: false },
  limit:       { type: 'number',  required: false },
  offset:      { type: 'number',  required: false },
})
